/* eslint-disable @typescript-eslint/no-explicit-any */
import "./UserInfo.css";
import "react-phone-number-input/style.css";
import Navbar from "../../../Components/Navbar/Navbar";
// import { FollowOtherCreators } from "../Influencer/MyNetwork/Follow";
import {
  ProfileForm,
  ContentForm,
  VerificationDataForm,
  CreateMediaKitForm,
} from "./UserInfoProps";
import { useUserInfoHooks } from "./UserinfoHooks";
import { SyncLinkedinWithExt } from "@/Pages/Influencer/CreateProfileV1/SyncLinkedinWithExt";
import { ExtPreviewData } from "@/Pages/Influencer/CreateProfileV1/ExtPreviewData";
import { useNavigate } from "react-router-dom";
import { UserInfoPreExtension } from "./UserInfoPreExtension";

const UserInfo = () => {
  const navigate = useNavigate();
  const {
    currentSection,
    fade,
    setCurrentSection,
    currentPage,
    setCurrentPage,
    isManually,
    setIsManually,
    profileData,
    setProfileData,
    profileFormImages,
    setProfileFormImages,
    handleSubmit,
    referCode,
    setReferCode,
    contentData,
    setContentData,
    verificationData,
    setVerficationData,
    MediaKitsheetsData,
    setMediaKitSheetsData,
  } = useUserInfoHooks();
  return (
    <>
      <div className="w-full  min-h-screen flex flex-col items-center justify-start bg-[#171717] h-full ">
        <Navbar bg={"#171717"} />
        {currentSection === "preExtension" && (
          <UserInfoPreExtension
            handleSubmit={() => setCurrentSection("extension")}
          />
        )}
        {currentSection === "extension" && (
          <>
            {!isManually && (
              <>
                {currentPage === "profile" && (
                  <SyncLinkedinWithExt
                    onSetManually={function (): void {
                      setIsManually(true);
                    }}
                  />
                )}
                {currentPage === "preview-data" && <ExtPreviewData />}
              </>
            )}
            {isManually && (
              <div
                className={`w-full h-full py-[25px] md:py-[70px] flex flex-col items-start px-[16px] ${
                  currentPage === "audience" ? "md:px-[10%]" : "md:px-[25%]"
                } text-[#FFFFFF] justify-center gap-[22px]  md:gap-[46px] bg-[#171717] transition-opacity duration-300 ${
                  fade ? "opacity-0" : "opacity-100"
                }`}
              >
                <div className=" flex flex-col items-start gap-[8px] ">
                  <h1 className="text-[14px] md:text-[24px] font-[600] font-inter">
                    Build Your Profile
                  </h1>
                </div>
                {currentPage === "profile" && (
                  <>
                    <ProfileForm
                      data={profileData}
                      setData={setProfileData}
                      formOneImages={profileFormImages}
                      setFormOneImages={setProfileFormImages}
                      onSubmit={() => handleSubmit()}
                      code={referCode}
                      setCode={setReferCode}
                    />
                  </>
                )}
                {currentPage === "mediaKit" && (
                  <>
                    <CreateMediaKitForm
                      data={MediaKitsheetsData}
                      setData={setMediaKitSheetsData}
                      onSubmit={() => handleSubmit()}
                      onSkip={() => setCurrentPage("content")}
                    />
                  </>
                )}
                {currentPage === "content" && (
                  <>
                    <ContentForm
                      data={contentData}
                      setData={setContentData}
                      onSubmit={() => handleSubmit()}
                    />
                  </>
                )}

                {currentPage === "verification" && (
                  <>
                    <VerificationDataForm
                      data={verificationData}
                      setData={setVerficationData}
                      onSuccess={() => navigate("/influencer/dashboard")}
                    />
                  </>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};
export default UserInfo;
